// Deliberately no hardcoded home address here: this file is imported by
// client-side code and bundled into the publicly-served JS, and static
// assets are not behind the auth gate (only /api/* is). Home address must
// never appear in unauthenticated HTML/JS — see worker/routes/rental.ts,
// which is the only place the real address is served, and only to an
// authenticated session. Callers here may pass an explicit origin (e.g.
// fetched from that authenticated endpoint); omitting it lets the native
// Maps app fall back to the device's current location, which is usually
// what you want anyway when you're not at home.

export function appleMapsUrl(destAddress: string, originAddress?: string): string {
  const params = new URLSearchParams({ daddr: destAddress, dirflg: 'd' });
  if (originAddress) params.set('saddr', originAddress);
  return `https://maps.apple.com/?${params.toString()}`;
}

export function googleMapsUrl(destAddress: string, originAddress?: string): string {
  const params = new URLSearchParams({
    api: '1',
    destination: destAddress,
    travelmode: 'driving',
  });
  if (originAddress) params.set('origin', originAddress);
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

export function wazeUrl(lat: number, lng: number): string {
  const params = new URLSearchParams({ ll: `${lat},${lng}`, navigate: 'yes' });
  return `https://waze.com/ul?${params.toString()}`;
}

export function telUrl(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}

export function smsUrl(phone: string): string {
  return `sms:${phone.replace(/[^\d+]/g, '')}`;
}

export function mailtoUrl(email: string): string {
  return `mailto:${email}`;
}
